import { useConnector } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';
import { useSearchDictionary } from '../../util';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';

export type UseStatsProps = StatsConnectorParams;

function useStats(props?: UseStatsProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats as any, props);
}

function SearchStatsWithSearch(props: UseStatsProps) {
  const { nbHits } = useStats(props);
  const dict = useSearchDictionary();
  const resultsCount = dict.resultsCountNoQuery.replace('@count', nbHits.toString());
  const noResults = nbHits === 0 ? true : false;

  return (
    <div className={classnames('flex-col')}>
      <div className={classnames('text-body', 'font-semibold', 'text-black')}>{resultsCount}</div>
      {noResults ? <div>{dict.educationnoresults}</div> : <></>}
    </div>
  );
}

const SearchListingStats = (props: UseStatsProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    return <></>;
  }
  return <SearchStatsWithSearch {...props} />;
};

export default SearchListingStats;
